<template>
  <div>
    <main-toolbar>
      <v-toolbar-title>Instructions</v-toolbar-title>
    </main-toolbar>
    <div class="text-center pa-2">
      <br />
      <h2 class="display-2">Welcome to the {{skinProp('secondaryName')}} Portal</h2>
      <br />
      <br />
      <br />
      <p class="subtitle-1">{{skinProp('secondaryName')}} allows you to quickly review the data, create graphs and analyze results.</p>
      <br />
    </div>
    <v-container>
      <v-layout wrap class="img-row">
        <v-flex sm12 md4 justify-center class="text-wrapper">
          <div>
            <div class="img-row-header"><i class="fa fa-chart-pie"></i> Graphs</div>
            allows you to create graphs within a specific date and time range.
          </div>
        </v-flex>
        <v-flex sm12 md8 class="img-wrapper">
          <div>
            <img src="img/instructions/dashboard2.jpg" width="100%" />
          </div>
        </v-flex>
      </v-layout>

      <v-layout wrap class="img-row">
        <v-flex sm12 md4 order-sm2 class="text-wrapper">
          <div>
            <div class="img-row-header"><i class="fa fa-database"></i> Data</div>
            allows you to select the date and time range to view your test results.
          </div>
        </v-flex>
        <v-flex sm12 md8 order-sm1 class="img-wrapper">
          <div>
            <img src="img/instructions/dashboard1.jpg" width="100%" />
          </div>
        </v-flex>
      </v-layout>

      <v-layout wrap class="img-row">
        <v-flex sm12 md4 class="text-wrapper">
          <div>
            <div class="img-row-header"><i class="fa fa-bell"></i> Alerts</div>
            allows you to select conditions for receiving notices by email or text message.
          </div>
        </v-flex>
        <v-flex sm12 md8 class="img-wrapper">
          <div>
            <img src="img/instructions/dashboard3.jpg" width="100%" />
          </div>
        </v-flex>
      </v-layout>

      <v-layout wrap class="row img-row">
        <v-flex sm12 md4 order-sm2 class="text-wrapper">
          <div>
            <div class="img-row-header"><i class="fa fa-newspaper"></i> Reports</div>
            allows you to select periodic reports summarizing monitoring results.
          </div>
        </v-flex>
        <v-flex sm12 md8 order-sm1 class="img-wrapper">
          <div>
            <img src="img/instructions/dashboard4.jpg" width="100%" />
          </div>
        </v-flex>
      </v-layout>
      <!--
      <div class="row img-row">
        <div class="col-sm-4 text-wrapper">
          <div>
            <div class="img-row-header"><i class="fa fa-support"></i> Support</div>
            informs you how to call for assistance.
          </div>
        </div>
        <div class="col-sm-8 img-wrapper text-center">
          <div>
            <img src="./dashboard5.jpg" style="max-height: 400px;" />
          </div>
        </div>
      </div>
      -->
    </v-container>
  </div>
</template>

<style lang="scss">
.img-row {
  margin-top: 30px;

  .img-row-header {
    margin-bottom: 5px;
    font-size: 1.3em;
  }

  .text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    > div {
      font-size: 1.3em;
      padding: 20px;
    }
  }

  .img-wrapper {
    > div {
      margin: 15px;
      border: #c0c0c0 1px solid;
      padding: 15px;
    }
  }
}
</style>

<script>
export default {
}
</script>
